<template>
    <div id="Settings-menu">
        <div class="header">
            <span class="md-icon" @click="$emit('close')">close</span>
            {{ title }}
        </div>
        <div class="content">
            <TitleSettings
                v-if="type === 'title'"
                :item="item"
                @update-title-size="updateTitleSize"
                @update-text-align="updateTextAlign"
                @update-title-text="updateTitleText"
                @update-subtitle-text="updateSubTitleText"
            />
            <FullNameSettings
                v-if="type === 'fullName'"
                :item="item"
                @update-field-label="updateFieldLabel"
                @update-label-align="updateLabelAlign"
                @update-first-name="updateFirstName"
                @update-last-name="updateLastName"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
                @update-slug="updateSlug"
            />
            <EmailSettings
                v-if="type === 'email'"
                :item="item"
                @update-field-email="updateFieldEmail"
                @update-label-align-mail="updateLabelAlignMail"
                @update-alt-label-mail="updateAltLabelMail"
                @update-visibility="updateVisibility"
                @update-required="updateRequired"
                @update-slug="updateSlug"
            />
            <AddressSettings
                v-if="type === 'address'"
                :item="item"
                @update-field-label-address="updateFieldLabelAddress"
                @update-label-align-address="updateLabelAlignAddress"
                @update-field-address-line-1="updateFieldAddressLine1"
                @update-field-address-line-2="updateFieldAddressLine2"
                @update-field-district="updateFieldDistrict"
                @update-field-postal-code="updateFieldPostalCode"
                @update-field-state="updateFieldState"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <PhoneSettings
                v-if="type === 'phone'"
                :item="item"
                @update-field-phone="updateFieldPhone"
                @update-label-align-phone="updateLabelAlignPhone"
                @update-masked-phone="updateMaskedPhone"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
                @update-slug="updateSlug"
            />
            <DatePickerSettings
                v-if="type === 'datePicker'"
                :item="item"
                @update-field-label-date-picker="updateFieldLabelDatePicker"
                @update-label-align-date-picker="updateLabelAlignDatePicker"
                @update-date-label-date-picker="updateDateLabelDatePicker"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <ShortTextSettings
                v-if="type === 'shortText'"
                :item="item"
                @update-field-label-short-text="updateFieldLabelShortText"
                @update-label-align-short-text="updateLabelAlignShortText"
                @update-alt-label-short-text="updateAltLabelShortText"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
                @update-slug="updateSlug"
            />
            <LongTextSettings
                v-if="type === 'longText'"
                :item="item"
                @update-field-label-long-text="updateFieldLabelLongText"
                @update-label-align-long-text="updateLabelAlignLongText"
                @update-alt-label-long-text="updateAltLabelLongText"
                @update-visibility="updateVisibility"
                @update-required="updateRequired"
                @update-slug="updateSlug"
            />
            <ParagraphSettings
                v-if="type === 'paragraph'"
                :item="item"
                @update-margin-top="updateMarginTopParagraph"
                @update-margin-bottom="updateMarginBottomParagraph"
            />
            <SignatureSettings
                v-if="type === 'signature'"
                :item="item"
                @update-field-label="updateSignatureFieldLabel"
                @update-align="updateSignatureAlign"
                @update-alt-label="updateSignatureAltLabel"
                @update-is-required="updateSignatureIsRequired"
                @update-canvas-width="updateSignatureCanvasWidth"
                @update-canvas-height="updateSignatureCanvasHeight"
                @update-stroke-color="updateSignatureStrokeColor"
                @update-stroke-width="updateSignatureStrokeWidth"
                @update-background-color="updateSignatureBackgroundColor"
                @update-border-color="updateSignatureBorderColor"
                @update-border-width="updateSignatureBorderWidth"
                @update-border-radius="updateSignatureBorderRadius"
                @update-show-clear-button="updateSignatureShowClearButton"
                @update-clear-button-text="updateSignatureClearButtonText"
                @update-placeholder="updateSignaturePlaceholder"
            />
            <CaptchaSettings
                v-if="type === 'captcha'"
                :item="item"
                @update-captcha-field-label="updateCaptchaFieldLabel"
                @update-captcha-align="updateCaptchaAlign"
                @update-captcha-placeholder="updateCaptchaPlaceholder"
                @update-captcha-is-required="updateCaptchaIsRequired"
            />
            <PageBreakSettings
                v-if="type === 'pagebreak'"
                :item="item"
                @update-pagebreak-align="updatePagebreakAlign"
                @update-pagebreak-next-button-text="updatePagebreakNextButtonText"
                @update-pagebreak-previous-button-text="updatePagebreakPreviousButtonText"
                @update-pagebreak-show-previous-button="updatePagebreakShowPreviousButton"
                @update-pagebreak-show-next-button="updatePagebreakShowNextButton"
            />
            <DropDownListSettings
                v-if="type === 'dropDownList'"
                :item="item"
                @update-field-label-drop-down-list="updateFieldLabelDropDownList"
                @update-placeholder-drop-down-list="updatePlaceholderDropDownList"
                @update-label-align-drop-down-list="updateLabelAlignDropDownList"
                @update-alt-label-drop-down-list="updateAltLabelDropDownList"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <SingleChoiceSettings
                v-if="type === 'singleChoice'"
                :item="item"
                @update-field-label-single-choice="updateFieldLabelSingleChoice"
                @update-label-align-single-choice="updateLabelAlignSingleChoice"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <MultipleSelectionSettings
                v-if="type === 'multipleSelection'"
                :item="item"
                @update-field-label-multiple-selection="updateFieldLabelMultipleSelection"
                @update-label-align-multiple-selection="updateLabelAlignMultipleSelection"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <NumberSettings
                v-if="type === 'number'"
                :item="item"
                @update-field-label-number="updateFieldLabelNumber"
                @update-label-align-number="updateLabelAlignNumber"
                @update-sub-label-number="updateSubLabelNumber"
                @update-required="updateRequired"
                @update-slug="updateSlug"
            />
            <HourSettings
                v-if="type === 'hour'"
                :item="item"
                @update-field-label-hour="updateFieldLabelHour"
                @update-label-align-hour="updateLabelAlignHour"
                @update-hour-label="updateHourLabel"
                @update-minute-label="updateMinuteLabel"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <SpinnerSettings
                v-if="type === 'spinner'"
                :item="item"
                @update-field-label-spinner="updateFieldLabelSpinner"
                @update-label-align-spinner="updateLabelAlignSpinner"
                @update-required="updateRequired"
                @update-visibility="updateVisibility"
            />
            <SendSettings
                v-if="type === 'send'"
                :item="item"
                @update-send-label="updateFieldLabelSend"
                @update-label-align-send="updateAlignmentSend"
            />

            <StarRatingSettings
                v-if="type === 'starRating'"
                :item="item"
                @update-field-label-star-rating="updateFieldLabelStarRating"
                @update-alignment-star-rating="updateAlignmentStarRating"
            />
            <RatingScaleSettings
                v-if="type === 'ratingScale'"
                :item="item"
                @update-field-label-rating-scale="updateFieldLabelRatingScale"
                @update-alignment-rating-scale="updateAlignmentRatingScale"
                @update-sub-label-one-rating-scale="updateRatingScaleSubLabelOne"
                @update-sub-label-two-rating-scale="updateRatingScaleSubLabelTwo"
            />
            <SeparationElementSettings
                v-if="type === 'separationElement'"
                :item="item"
                @update-separation-color="updateSeparationColor"
                @update-separator-style="updateSeparatorStyle"
                @update-separator-height="updateSeparatorHeight"
                @update-separator-bottom="updateSeparatorBottom"
                @update-separator-top="updateSeparatorTop"
                @update-separator-side="updateSeparatorSide"
            />
            <FileUploadSettings
                v-if="type === 'fileUpload'"
                :item="item"
                @update-file-label="updateFileLabel"
                @update-file-alt-label-one="updateFileAltLabelOne"
                @update-file-alt-label-two="updateFileAltLabelTwo"
                @update-file-align="updateFileAlign"
                @update-file-required="updateRequired"
            />
            <ImageSettings
                v-if="type === 'image'"
                :item="item"
                @update-image-url="updateImageUrl"
                @update-image-width="updateImageWidth"
                @update-image-height="updateImageHeight"
                @update-image-align="updateImageAlign"
            />
        </div>
    </div>
</template>
<script>
import TitleSettings from "./TitleSettings.vue";
import FullNameSettings from "./FullNameSettings.vue";
import EmailSettings from "./EmailSettings.vue";
import AddressSettings from "./AddressSettings.vue";
import PhoneSettings from "./PhoneSettings.vue";
import DatePickerSettings from "./DatePickerSettings.vue";
import ShortTextSettings from "./ShortTextSettings.vue";
import LongTextSettings from "./LongTextSettings.vue";
import ParagraphSettings from "./ParagraphSettings.vue";
import SignatureSettings from "./SignatureSettings.vue";
import CaptchaSettings from "./CaptchaSettings.vue";
import PageBreakSettings from "./PageBreakSettings.vue";
import DropDownListSettings from "./DropDownListSettings.vue";
import SingleChoiceSettings from "./SingleChoiceSettings.vue";
import MultipleSelectionSettings from "./MultipleSelectionSettings.vue";
import NumberSettings from "./NumberSettings.vue";
import HourSettings from "./HourSettings.vue";
import SpinnerSettings from "./SpinnerSettings.vue";
import SendSettings from "./SendSettings.vue";
import StarRatingSettings from "./StarRatingSettings.vue";
import RatingScaleSettings from "./RatingScaleSettings.vue";
import SeparationElementSettings from "./SeparationElementSettings.vue";
import FileUploadSettings from "./FileUploadSettings.vue";
import ImageSettings from "./ImageSettings.vue";

export default {
    name: "SettingsMenu",
    components: {
        TitleSettings,
        FullNameSettings,
        EmailSettings,
        AddressSettings,
        PhoneSettings,
        DatePickerSettings,
        ShortTextSettings,
        LongTextSettings,
        ParagraphSettings,
        SignatureSettings,
        CaptchaSettings,
        PageBreakSettings,
        DropDownListSettings,
        SingleChoiceSettings,
        MultipleSelectionSettings,
        NumberSettings,
        HourSettings,
        SpinnerSettings,
        SendSettings,
        StarRatingSettings,
        RatingScaleSettings,
        SeparationElementSettings,
        FileUploadSettings,
        ImageSettings,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            title: "Ayarlar",
        };
    },
    methods: {
        menuTitle() {
            if (this.type === "title") {
                return (this.title = this.$t('form.title.titleSettings'));
            } else if (this.type === "fullName") {
                return (this.title = this.$t('form.title.fullNameSettings'));
            } else if (this.type === "email") {
                return (this.title = this.$t('form.title.emailSettings'));
            } else if (this.type === "address") {
                return (this.title = this.$t('form.title.addressSettings'));
            } else if (this.type === "phone") {
                return (this.title = this.$t('form.title.phoneSettings'));
            } else if (this.type === "datePicker") {
                return (this.title = this.$t('form.title.datePickerSettings'));
            } else if (this.type === "shortText") {
                return (this.title = this.$t('form.title.shortTextSettings'));
            } else if (this.type === "longText") {
                return (this.title = this.$t('form.title.longTextSettings'));
            } else if (this.type === "dropDownList") {
                return (this.title = this.$t('form.title.dropDownListSettings'));
            } else if (this.type === "singleChoice") {
                return (this.title = this.$t('form.title.singleChoiceSettings'));
            } else if (this.type === "multipleSelection") {
                return (this.title = this.$t('form.title.multipleSelectionSettings'));
            } else if (this.type === "number") {
                return (this.title = this.$t('form.title.numberSettings'));
            } else if (this.type === "hour") {
                return (this.title = this.$t('form.title.hourSettings'));
            } else if (this.type === "spinner") {
                return (this.title = this.$t('form.title.spinnerSettings'));
            } else if (this.type === "send") {
                return (this.title = this.$t('form.title.sendSettings'));
            } else if (this.type === "starRating") {
                return (this.title = this.$t('form.title.starRatingSettings'));
            } else if (this.type === "ratingScale") {
                return (this.title = this.$t('form.title.ratingScaleSettings'));
            } else if (this.type === "separationElement") {
                return (this.title = this.$t('form.title.separationElementSettings'));
            } else if (this.type === "fileUpload") {
                return (this.title = this.$t('form.title.fileUploadSettings'));
            } else if (this.type === "image") {
                return (this.title = this.$t('form.title.imageSettings'));
            } else if (this.type === "paragraph") {
                return (this.title = "Paragraf Ayarları");
            } else if (this.type === "signature") {
                return (this.title = "İmza Ayarları");
            } else if (this.type === "captcha") {
                return (this.title = "Captcha Ayarları");
            } else if (this.type === "pagebreak") {
                return (this.title = "Sayfa Sonu Ayarları");
            }
        },
        updateTitleSize(size) {
            this.$emit("update-title-size", size);
        },
        updateTextAlign(align) {
            this.$emit("update-text-align", align);
        },
        updateTitleText(text) {
            this.$emit("update-title-text", text);
        },
        updateSubTitleText(text) {
            this.$emit("update-subtitle-text", text);
        },
        updateFieldLabel(label) {
            this.$emit("update-field-label", label);
        },
        updateLabelAlign(align) {
            this.$emit("update-label-align", align);
        },
        updateFirstName(name) {
            this.$emit("update-first-name", name);
        },
        updateLastName(name) {
            this.$emit("update-last-name", name);
        },
        updateFieldEmail(email) {
            this.$emit("update-field-email", email);
        },
        updateLabelAlignMail(align) {
            this.$emit("update-label-align-mail", align);
        },
        updateAltLabelMail(label) {
            this.$emit("update-alt-label-mail", label);
        },
        updateFieldLabelAddress(label) {
            this.$emit("update-field-label-address", label);
        },
        updateLabelAlignAddress(align) {
            this.$emit("update-label-align-address", align);
        },
        updateFieldAddressLine1(address) {
            this.$emit("update-field-address-line-1", address);
        },
        updateFieldAddressLine2(address) {
            this.$emit("update-field-address-line-2", address);
        },
        updateFieldDistrict(district) {
            this.$emit("update-field-district", district);
        },
        updateFieldPostalCode(postalCode) {
            this.$emit("update-field-postal-code", postalCode);
        },
        updateFieldState(state) {
            this.$emit("update-field-state", state);
        },
        updateFieldPhone(phone) {
            this.$emit("update-field-phone", phone);
        },
        updateLabelAlignPhone(align) {
            this.$emit("update-label-align-phone", align);
        },
        updateMaskedPhone(masked) {
            this.$emit("update-masked-phone", masked);
        },
        updateFieldLabelDatePicker(label) {
            this.$emit("update-field-label-date-picker", label);
        },
        updateLabelAlignDatePicker(align) {
            this.$emit("update-label-align-date-picker", align);
        },
        updateDateLabelDatePicker(label) {
            this.$emit("update-date-label-date-picker", label);
        },
        updateFieldLabelShortText(label) {
            this.$emit("update-field-label-short-text", label);
        },
        updateLabelAlignShortText(align) {
            this.$emit("update-label-align-short-text", align);
        },
        updateAltLabelShortText(label) {
            this.$emit("update-alt-label-short-text", label);
        },
        updateFieldLabelLongText(label) {
            this.$emit("update-field-label-long-text", label);
        },
        updateLabelAlignLongText(align) {
            this.$emit("update-label-align-long-text", align);
        },
        updateAltLabelLongText(label) {
            this.$emit("update-alt-label-long-text", label);
        },
        updateFieldLabelDropDownList(label) {
            this.$emit("update-field-label-drop-down-list", label);
        },
        updatePlaceholderDropDownList(placeholder) {
            this.$emit("update-placeholder-drop-down-list", placeholder);
        },
        updateLabelAlignDropDownList(align) {
            this.$emit("update-label-align-drop-down-list", align);
        },
        updateAltLabelDropDownList(label) {
            this.$emit("update-alt-label-drop-down-list", label);
        },
        updateFieldLabelSingleChoice(label) {
            this.$emit("update-field-label-single-choice", label);
        },
        updateLabelAlignSingleChoice(align) {
            this.$emit("update-label-align-single-choice", align);
        },
        updateFieldLabelMultipleSelection(label) {
            this.$emit("update-field-label-multiple-selection", label);
        },
        updateLabelAlignMultipleSelection(align) {
            this.$emit("update-label-align-multiple-selection", align);
        },
        updateFieldLabelNumber(label) {
            this.$emit("update-field-label-number", label);
        },
        updateLabelAlignNumber(align) {
            this.$emit("update-label-align-number", align);
        },
        updateSubLabelNumber(subLabel) {
            this.$emit("update-sub-label-number", subLabel);
        },
        updateFieldLabelHour(label) {
            this.$emit("update-field-label-hour", label);
        },
        updateLabelAlignHour(align) {
            this.$emit("update-label-align-hour", align);
        },
        updateHourLabel(label) {
            this.$emit("update-hour-label", label);
        },
        updateMinuteLabel(label) {
            this.$emit("update-minute-label", label);
        },
        updateFieldLabelSpinner(label) {
            this.$emit("update-field-label-spinner", label);
        },
        updateFieldLabelSend(label) {
            this.$emit("update-field-label-send", label);
        },
        updateAlignmentSend(align) {
            this.$emit("update-label-align-send", align);
        },
        updateLabelAlignSpinner(align) {
            this.$emit("update-label-align-spinner", align);
        },
        updateFieldLabelStarRating(label) {
            this.$emit("update-field-label-star-rating", label);
        },
        updateAlignmentStarRating(align) {
            this.$emit("update-alignment-star-rating", align);
        },
        updateFieldLabelRatingScale(label) {
            this.$emit("update-field-label-rating-scale", label);
        },
        updateAlignmentRatingScale(align) {
            this.$emit("update-alignment-rating-scale", align);
        },
        updateRatingScaleSubLabelOne(label) {
            this.$emit("update-sub-label-one-rating-scale", label);
        },
        updateRatingScaleSubLabelTwo(label) {
            this.$emit("update-sub-label-two-rating-scale", label);
        },
        updateSeparationColor(color) {
            this.$emit("update-separation-color", color);
        },
        updateSeparatorStyle(style) {
            this.$emit("update-separator-style", style);
        },
        updateSeparatorHeight(height) {
            this.$emit("update-separator-height", height);
        },
        updateSeparatorBottom(bottom) {
            this.$emit("update-separator-bottom", bottom);
        },
        updateSeparatorTop(top) {
            this.$emit("update-separator-top", top);
        },
        updateSeparatorSide(side) {
            this.$emit("update-separator-side", side);
        },
        updateFileLabel(label) {
            this.$emit("update-file-label", label);
        },
        updateFileAltLabelOne(label) {
            this.$emit("update-file-alt-label-one", label);
        },
        updateFileAltLabelTwo(label) {
            this.$emit("update-file-alt-label-two", label);
        },
        updateFileAlign(align) {
            this.$emit("update-file-align", align);
        },
        updateRequired(required) {
            this.$emit("update-required", required);
        },
        updateImageUrl(url) {
            this.$emit("update-image-url", url);
        },
        updateImageWidth(width) {
            this.$emit("update-image-width", width);
        },
        updateImageHeight(height) {
            this.$emit("update-image-height", height);
        },
        updateImageAlign(align) {
            this.$emit("update-image-align", align);
        },
        updateVisibility(visibility) {
            this.$emit("update-visibility", visibility);
        },
        updateSlug(slug) {
            this.$emit("update-slug", slug);
        },
        updateMarginTopParagraph(marginTop) {
            this.$emit("update-margin-top", marginTop);
        },
        updateMarginBottomParagraph(marginBottom) {
            this.$emit("update-margin-bottom", marginBottom);
        },
        updateSignatureFieldLabel(fieldLabel) {
            this.$emit("update-signature-field-label", fieldLabel);
        },
        updateSignatureAlign(align) {
            this.$emit("update-signature-align", align);
        },
        updateSignatureAltLabel(altLabel) {
            this.$emit("update-signature-alt-label", altLabel);
        },
        updateSignatureIsRequired(isRequired) {
            this.$emit("update-signature-is-required", isRequired);
        },
        updateSignatureCanvasWidth(canvasWidth) {
            this.$emit("update-signature-canvas-width", canvasWidth);
        },
        updateSignatureCanvasHeight(canvasHeight) {
            this.$emit("update-signature-canvas-height", canvasHeight);
        },
        updateSignatureStrokeColor(strokeColor) {
            this.$emit("update-signature-stroke-color", strokeColor);
        },
        updateSignatureStrokeWidth(strokeWidth) {
            this.$emit("update-signature-stroke-width", strokeWidth);
        },
        updateSignatureBackgroundColor(backgroundColor) {
            this.$emit("update-signature-background-color", backgroundColor);
        },
        updateSignatureBorderColor(borderColor) {
            this.$emit("update-signature-border-color", borderColor);
        },
        updateSignatureBorderWidth(borderWidth) {
            this.$emit("update-signature-border-width", borderWidth);
        },
        updateSignatureBorderRadius(borderRadius) {
            this.$emit("update-signature-border-radius", borderRadius);
        },
        updateSignatureShowClearButton(showClearButton) {
            this.$emit("update-signature-show-clear-button", showClearButton);
        },
        updateSignatureClearButtonText(clearButtonText) {
            this.$emit("update-signature-clear-button-text", clearButtonText);
        },
        updateSignaturePlaceholder(placeholder) {
            this.$emit("update-signature-placeholder", placeholder);
        },
        updateCaptchaFieldLabel(fieldLabel) {
            this.$emit("update-captcha-field-label", fieldLabel);
        },
        updateCaptchaAlign(align) {
            this.$emit("update-captcha-align", align);
        },
        updateCaptchaPlaceholder(placeholder) {
            this.$emit("update-captcha-placeholder", placeholder);
        },
        updateCaptchaIsRequired(isRequired) {
            this.$emit("update-captcha-is-required", isRequired);
        },
        updatePagebreakAlign(align) {
            this.$emit("update-pagebreak-align", align);
        },
        updatePagebreakNextButtonText(nextButtonText) {
            this.$emit("update-pagebreak-next-button-text", nextButtonText);
        },
        updatePagebreakPreviousButtonText(previousButtonText) {
            this.$emit("update-pagebreak-previous-button-text", previousButtonText);
        },
        updatePagebreakShowPreviousButton(showPreviousButton) {
            this.$emit("update-pagebreak-show-previous-button", showPreviousButton);
        },
        updatePagebreakShowNextButton(showNextButton) {
            this.$emit("update-pagebreak-show-next-button", showNextButton);
        },
    },
    mounted() {
        this.menuTitle();
    },
};
</script>

<style lang="scss" scoped>
#Settings-menu {
    width: 100%;
    background-color: #fff;
    border: 1px solid #e9edf3;
    box-shadow: 0 10px 30px rgba(21, 25, 36, 0.12);
    border-top-left-radius: 12px;
    overflow: hidden;
    font-family: "Roboto", sans-serif;
    height: 100%;

    .header {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px 16px 18px 16px;
        background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
        color: #ffffff;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        border-top-left-radius: 12px;
        font-weight: 600;
        font-size: 1.05rem;
        line-height: 1.15;

        .md-icon {
            position: absolute;
            right: 12px;
            top: 12px;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.1rem;
            cursor: pointer;
            color: #ffffff;
            background: rgba(255, 255, 255, 0.16);
            border-radius: 50%;
            transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.22);
                transform: scale(1.04);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
            }
        }
    }

    .content {
        padding: 16px;
        overflow-y: auto;
        height: calc(100vh - 120px);
        max-height: calc(100vh - 120px);
    }
}
</style>
